import type { AssetTypeCategoryProps } from "./asset-type-category.type";

import { useAssetTypeCategory } from "./asset-type-category.hook";

const AssetTypeCategory = ({ assetType, fallback }: AssetTypeCategoryProps) => {
  const category = useAssetTypeCategory(assetType);

  if (!category) return fallback ?? null;

  return category.name;
};

export default AssetTypeCategory;
